// import external dependencies
import 'jquery';

// Import everything from autoload
import './autoload/_bootstrap.js'

import AOS from 'aos';

jQuery(window).on('load', function () {
  AOS.refresh();
});

AOS.init({
  offset: 0,
  duration: 1200,
});

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());
